import { FC, Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import {
	AuthProvider,
	ErrorBoundary,
	ErrorDetailsDialog,
	ErrorProvider,
	NotificationsProvider,
	ShareProvider,
	TranslationsProvider,
	StoreProvider
} from './providers';
import { RoutesContainer } from './routes';
import { FiltersProvider } from './providers/filters-provider/provider';
import { ChatNotificationsProvider } from './providers/chat-notifications/provider';
import Loader from './components/Loader';

const App: FC = () => {
	useEffect(() => {
		const setVh = (): void => {
			const vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		};

		// Set the initial value
		setVh();

		// Update the value on resize
		window.addEventListener('resize', setVh);
		return () => {
			window.removeEventListener('resize', setVh);
		};
	}, []);

	return (
		<Suspense fallback={<Loader />}>
			<ErrorProvider>
				<ErrorBoundary>
					<StoreProvider>
						<AuthProvider>
							{/* Textele modificate din BE (GET api/translations) se încarcă la
								pornire, în context autentificat, și se aplică peste textele i18n. */}
							<TranslationsProvider>
								{/* împachetează aplicația: consumatorii useSnackbar() au nevoie de
									contextul SnackbarProvider (implicitul notistack e un no-op) */}
								<NotificationsProvider>
									<BrowserRouter>
										<FiltersProvider>
											<ShareProvider>
												<ChatNotificationsProvider>
													<RoutesContainer />
												</ChatNotificationsProvider>
											</ShareProvider>
										</FiltersProvider>
									</BrowserRouter>
								</NotificationsProvider>
							</TranslationsProvider>
						</AuthProvider>
					</StoreProvider>
				</ErrorBoundary>
				<ErrorDetailsDialog />
			</ErrorProvider>
		</Suspense>
	);
};

export default App;
